(() => {
  if (window.ETDesignSearchNativeLoaded) return;
  window.ETDesignSearchNativeLoaded = true;

  const endpoint = '/apps/design-engine/design-search';
  const randomId = () => window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : Date.now() + '_' + Math.random().toString(36).slice(2);

  let sessionId = '';
  try {
    sessionId = sessionStorage.getItem('et_design_search_session') || randomId();
    sessionStorage.setItem('et_design_search_session', sessionId);
  } catch (error) {
    sessionId = randomId();
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function resultItem(result, state) {
    const item = element('li', 'predictive-search__product-suggestion');
    const link = element('a', 'predictive-search__product-suggestion-link');
    link.href = result.url;
    link.dataset.designSearchResult = '';
    link.dataset.designId = String(result.designId || '');

    const figure = element('figure', 'predictive-search__product-suggestion-image et-native-design-search__image');
    const image = document.createElement('img');
    image.src = result.image;
    image.alt = result.title + ' design artwork';
    image.width = 96;
    image.height = 96;
    image.loading = 'lazy';
    figure.appendChild(image);

    const details = element('div', 'predictive-search__product-suggestion-details');
    details.appendChild(element('span', 'predictive-search__product-suggestion-title', result.title));
    if (result.primaryTopic) {
      details.appendChild(element('span', 'et-native-design-search__topic', result.primaryTopic));
    }

    link.append(figure, details);
    item.appendChild(link);
    return item;
  }

  function garmentItem(garment) {
    const item = element('a', 'et-native-design-search__garment');
    item.href = garment.url;
    const copy = element('span', 'et-native-design-search__garment-copy');
    copy.appendChild(element('strong', '', 'Shop ' + garment.label));
    copy.appendChild(element('small', '', 'Browse all designs in this style'));
    item.appendChild(copy);
    item.appendChild(element('span', 'et-native-design-search__garment-arrow', '→'));
    return item;
  }

  function renderResults(resultsRoot, data, state) {
    resultsRoot.replaceChildren();
    const panel = element('div', 'predictive-search');

    const header = element('div', 'predictive-search__header et-native-design-search__header');
    const total = Number(data.total || 0);
    const headingText = total > 0
      ? total + ' matching ' + (total === 1 ? 'design' : 'designs')
      : data.garment ? 'Shop by garment' : 'Matching designs';
    header.appendChild(element('h2', 'predictive-search__heading', headingText));

    if (total > 0) {
      const all = element('a', 'et-native-design-search__all-results', 'See all results');
      all.href = '/search?q=' + encodeURIComponent(state.query);
      header.appendChild(all);
    }
    panel.appendChild(header);

    if (data.garment) panel.appendChild(garmentItem(data.garment));

    if ((!data.results || data.results.length === 0) && !data.garment) {
      header.appendChild(element('p', 'predictive-search__no-results', 'No matching designs yet. Try another phrase.'));
    } else if (data.results && data.results.length > 0) {
      const main = element('div', 'predictive-search__main');
      const column = element('div', 'predictive-search__main-column');
      const list = element('ul', 'predictive-search__product-suggestions');
      data.results.forEach(result => list.appendChild(resultItem(result, state)));
      column.appendChild(list);
      main.appendChild(column);
      panel.appendChild(main);
    }

    resultsRoot.appendChild(panel);
  }

  function initializeForm(form) {
    if (form.dataset.designSearchReady === 'true') return;
    form.dataset.designSearchReady = 'true';

    const input = form.querySelector('[data-search-input]');
    const container = form.querySelector('[data-design-search-results-container]');
    const resultsRoot = form.querySelector('[data-design-search-results]');
    if (!input || !container || !resultsRoot) return;

    const state = {
      timer: null,
      controller: null,
      query: '',
      searchId: ''
    };

    const close = () => {
      container.removeAttribute('data-animation');
      container.removeAttribute('data-animation-state');
      container.dataset.loading = 'false';
      resultsRoot.replaceChildren();
    };

    const open = () => {
      container.dataset.animation = '';
      container.dataset.animationState = 'open';
    };

    const searchDesigns = async () => {
      const query = input.value.trim();
      state.query = query;
      state.searchId = '';
      if (query.length < 2) {
        close();
        return;
      }

      if (state.controller) state.controller.abort();
      state.controller = new AbortController();
      container.dataset.loading = 'true';
      open();

      const searchId = randomId();
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('limit', '6');
      url.searchParams.set('search_id', searchId);
      url.searchParams.set('session_id', sessionId);
      url.searchParams.set('mode', 'predictive');

      try {
        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' },
          signal: state.controller.signal
        });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        if (query !== input.value.trim()) return;
        state.searchId = data.search_id || searchId;
        renderResults(resultsRoot, data, state);
        container.dataset.loading = 'false';
      } catch (error) {
        if (error.name === 'AbortError') return;
        close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(state.timer);
      state.timer = setTimeout(searchDesigns, 350);
    });

    input.addEventListener('focus', () => {
      if (resultsRoot.childElementCount > 0) open();
    });

    resultsRoot.addEventListener('click', event => {
      const link = event.target.closest('[data-design-search-result]');
      if (!link || !state.query || !state.searchId) return;

      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('event', 'click');
      url.searchParams.set('q', state.query);
      url.searchParams.set('search_id', state.searchId);
      url.searchParams.set('session_id', sessionId);
      url.searchParams.set('design_id', link.dataset.designId || '');
      fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        keepalive: true
      }).catch(() => {});
    });

    document.addEventListener('click', event => {
      if (!form.contains(event.target)) close();
    });
  }

  const initialize = () => {
    document.querySelectorAll('[data-design-search-form]').forEach(initializeForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();

